var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { D2C_PLUGINS_LOADED_EVENT } from './constants/plugin-constants';
import EventTracker from './event-tracker';
import { ControlPluginTypes, DefaultPluginTypes, PluginTypes } from './plugins/';
import { asyncWithRetries, validateConfigSchema } from './utils/utils';
var PluginManager = /** @class */ (function () {
    function PluginManager(config, logger, dataLayer) {
        this.plugins = {};
        this.config = config;
        this.logger = logger;
        this.dataLayer = dataLayer;
        if (validateConfigSchema(this.config)) {
            this.init();
        }
        else {
            this.logger.error('Configuration is not valid.');
        }
    }
    PluginManager.prototype.getPlugin = function (pluginType) {
        var _a;
        return ((_a = this.plugins[pluginType]) === null || _a === void 0 ? void 0 : _a.instance) || null;
    };
    PluginManager.prototype.initializePlugins = function () {
        this.onAllPlugins(function (plugin, eventParam) {
            plugin.init(eventParam);
        });
        this.dispatchPluginLoadedEvent();
    };
    PluginManager.prototype.destroyPlugins = function () {
        this.onAllPlugins(function (plugin) {
            plugin.destroy();
        });
    };
    PluginManager.prototype.dispatchPluginLoadedEvent = function () {
        document.dispatchEvent(new CustomEvent(D2C_PLUGINS_LOADED_EVENT));
    };
    PluginManager.prototype.onAllPlugins = function (callback) {
        for (var _i = 0, _a = Object.entries(this.plugins); _i < _a.length; _i++) {
            var _b = _a[_i], _c = _b[1], instance = _c.instance, eventParams = _c.eventParams;
            callback(instance, eventParams);
        }
    };
    PluginManager.prototype.init = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        new EventTracker(((_a = this.config.controlEvents) === null || _a === void 0 ? void 0 : _a.length) > 0);
                        return [4 /*yield*/, this.loadPlugins()];
                    case 1:
                        _b.sent();
                        this.initializePlugins();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        this.logger.error(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PluginManager.prototype.getParamsIfOverriden = function (event) {
        var _a;
        // Currently, disabling any parameter overrides for pageView
        // as there is nothing to override
        if (event === PluginTypes.defaultPageView) {
            return null;
        }
        var overrideDefaultEvents = this.config.overrideDefaultEvents;
        // In case the event is not overriden, simply return null
        if (!(overrideDefaultEvents === null || overrideDefaultEvents === void 0 ? void 0 : overrideDefaultEvents[event])) {
            return null;
        }
        var params = (_a = {},
            _a[event] = overrideDefaultEvents === null || overrideDefaultEvents === void 0 ? void 0 : overrideDefaultEvents[event],
            _a);
        return params;
    };
    PluginManager.prototype.isDefaultEvent = function (event) {
        return Boolean(DefaultPluginTypes[event]);
    };
    PluginManager.prototype.isControlEvent = function (event) {
        return Boolean(ControlPluginTypes[event]);
    };
    PluginManager.prototype.isEventDisabled = function (event) {
        if (this.isDefaultEvent(event)) {
            var disableDefaultEvents = this.config.disableDefaultEvents;
            return disableDefaultEvents === null || disableDefaultEvents === void 0 ? void 0 : disableDefaultEvents.includes(event);
        }
        return false;
    };
    PluginManager.prototype.isControlEventEnabled = function (event) {
        var controlEvents = this.config.controlEvents;
        return controlEvents === null || controlEvents === void 0 ? void 0 : controlEvents.includes(event);
    };
    PluginManager.prototype.getEnabledEvents = function () {
        var events = [];
        var pluginTypes = Object.keys(PluginTypes);
        for (var i = 0; i < pluginTypes.length; ++i) {
            var event_1 = pluginTypes[i];
            if (this.isEventDisabled(event_1)) {
                // We give precedence to disabled section in case a particular event is present in
                // both disabled and overrides.
                // eg. disableDefaultEvents: ['defaultClick'],
                //     overrideDefaultEvents: {
                //        defaultClick: {
                //          ignoreTrackIdentifier: ''
                //        }
                //     }
                continue;
            }
            var paramsToOverride = this.getParamsIfOverriden(event_1);
            if (paramsToOverride) {
                events.push(paramsToOverride);
                continue;
            }
            if (this.isControlEvent(event_1) && !this.isControlEventEnabled(event_1)) {
                continue;
            }
            // Add the event. This will be a default event without overrides, control event.
            events.push(event_1);
        }
        return events;
    };
    PluginManager.prototype.loadPlugins = function () {
        return __awaiter(this, void 0, void 0, function () {
            var events, pluginType, eventParams, _a, _b, _c, _i, i, event_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        events = this.getEnabledEvents();
                        _a = events;
                        _b = [];
                        for (_c in _a)
                            _b.push(_c);
                        _i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(_i < _b.length)) return [3 /*break*/, 4];
                        _c = _b[_i];
                        if (!(_c in _a)) return [3 /*break*/, 3];
                        i = _c;
                        event_2 = events[i];
                        if (!event_2) return [3 /*break*/, 3];
                        pluginType = event_2;
                        eventParams = undefined;
                        if (typeof event_2 !== 'string') {
                            pluginType = Object.keys(event_2)[0];
                            eventParams = event_2[pluginType];
                        }
                        return [4 /*yield*/, this.loadPlugin(pluginType, eventParams)];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PluginManager.prototype.getDynamicallyImportedPluginBasedOnType = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Needed to ensure the files are code-split.
                // If we use it from a variable, the bundler doesn't know to code-spit them.
                switch (type) {
                    case 'defaultPageView':
                        return [2 /*return*/, import("./plugins/default-page-view-plugin")];
                    case 'defaultClick':
                        return [2 /*return*/, import("./plugins/default-click-plugin")];
                    case 'controlClick':
                        return [2 /*return*/, import("./plugins/control-click-plugin")];
                }
                return [2 /*return*/];
            });
        });
    };
    PluginManager.prototype.loadPlugin = function (pluginType, eventParams) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, status, result, error, PluginClass;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, asyncWithRetries(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, this.getDynamicallyImportedPluginBasedOnType(pluginType)];
                            });
                        }); })];
                    case 1:
                        _a = _b.sent(), status = _a.status, result = _a.result, error = _a.error;
                        if (status) {
                            this.logger.log("Plugin: ".concat(pluginType, " successfully loaded dynamically"));
                            PluginClass = result.default;
                            this.plugins[pluginType] = {
                                instance: new PluginClass({
                                    dataLayer: this.dataLayer,
                                    logger: this.logger,
                                    pluginName: PluginTypes[pluginType],
                                }),
                                eventParams: eventParams,
                            };
                        }
                        else {
                            this.logger.error("Plugin: ".concat(pluginType, " failed to load due to the error: ").concat(error));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return PluginManager;
}());
export default PluginManager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGx1Z2luLW1hbmFnZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcGx1Z2luLW1hbmFnZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLHdCQUF3QixFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFFeEUsT0FBTyxZQUFZLE1BQU0saUJBQWlCLENBQUM7QUFFM0MsT0FBTyxFQUFFLGtCQUFrQixFQUFFLGtCQUFrQixFQUFrRCxXQUFXLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFDakksT0FBTyxFQUFFLGdCQUFnQixFQUFFLG9CQUFvQixFQUFFLE1BQU0sZUFBZSxDQUFDO0FBVXZFO0lBTUUsdUJBQVksTUFBa0MsRUFBRSxNQUFjLEVBQUUsU0FBcUM7UUFMN0YsWUFBTyxHQUF1QixFQUF3QixDQUFDO1FBTTdELElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1FBQ3JCLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1FBRTNCLElBQUksb0JBQW9CLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxFQUFFO1lBQ3JDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztTQUNiO2FBQU07WUFDTCxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyw2QkFBNkIsQ0FBQyxDQUFDO1NBQ2xEO0lBQ0gsQ0FBQztJQUVELGlDQUFTLEdBQVQsVUFBVSxVQUFvQzs7UUFDNUMsT0FBTyxDQUFBLE1BQUEsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUMsMENBQUUsUUFBUSxLQUFJLElBQUksQ0FBQztJQUNwRCxDQUFDO0lBRUQseUNBQWlCLEdBQWpCO1FBQ0UsSUFBSSxDQUFDLFlBQVksQ0FBQyxVQUFDLE1BQWMsRUFBRSxVQUFtQjtZQUNwRCxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQzFCLENBQUMsQ0FBQyxDQUFDO1FBQ0gsSUFBSSxDQUFDLHlCQUF5QixFQUFFLENBQUM7SUFDbkMsQ0FBQztJQUVELHNDQUFjLEdBQWQ7UUFDRSxJQUFJLENBQUMsWUFBWSxDQUFDLFVBQUMsTUFBYztZQUMvQixNQUFNLENBQUMsT0FBTyxFQUFFLENBQUM7UUFDbkIsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU8saURBQXlCLEdBQWpDO1FBQ0UsUUFBUSxDQUFDLGFBQWEsQ0FBQyxJQUFJLFdBQVcsQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDLENBQUM7SUFDcEUsQ0FBQztJQUVPLG9DQUFZLEdBQXBCLFVBQXFCLFFBQXdEO1FBQzNFLEtBQTRDLFVBQTRCLEVBQTVCLEtBQUEsTUFBTSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQTVCLGNBQTRCLEVBQTVCLElBQTRCLEVBQUU7WUFBL0QsSUFBQSxXQUE2QixFQUExQixVQUF5QixFQUF2QixRQUFRLGNBQUEsRUFBRSxXQUFXLGlCQUFBO1lBQ25DLFFBQVEsQ0FBQyxRQUFRLEVBQUUsV0FBVyxDQUFDLENBQUM7U0FDakM7SUFDSCxDQUFDO0lBRWEsNEJBQUksR0FBbEI7Ozs7Ozs7O3dCQUVJLElBQUksWUFBWSxDQUFDLENBQUEsTUFBQSxJQUFJLENBQUMsTUFBTSxDQUFDLGFBQWEsMENBQUUsTUFBTSxJQUFHLENBQUMsQ0FBQyxDQUFDO3dCQUN4RCxxQkFBTSxJQUFJLENBQUMsV0FBVyxFQUFFLEVBQUE7O3dCQUF4QixTQUF3QixDQUFDO3dCQUN6QixJQUFJLENBQUMsaUJBQWlCLEVBQUUsQ0FBQzs7Ozt3QkFFekIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBRyxDQUFDLENBQUM7Ozs7OztLQUUxQjtJQUVPLDRDQUFvQixHQUE1QixVQUE2QixLQUErQjs7UUFDMUQsNERBQTREO1FBQzVELGtDQUFrQztRQUNsQyxJQUFJLEtBQUssS0FBSyxXQUFXLENBQUMsZUFBZSxFQUFFO1lBQ3pDLE9BQU8sSUFBSSxDQUFDO1NBQ2I7UUFFTyxJQUFBLHFCQUFxQixHQUFLLElBQUksQ0FBQyxNQUFNLHNCQUFoQixDQUFpQjtRQUU5Qyx5REFBeUQ7UUFDekQsSUFBSSxDQUFDLENBQUEscUJBQXFCLGFBQXJCLHFCQUFxQix1QkFBckIscUJBQXFCLENBQUcsS0FBSyxDQUFDLENBQUEsRUFBRTtZQUNuQyxPQUFPLElBQUksQ0FBQztTQUNiO1FBRUQsSUFBTSxNQUFNO1lBQ1YsR0FBQyxLQUFLLElBQUcscUJBQXFCLGFBQXJCLHFCQUFxQix1QkFBckIscUJBQXFCLENBQUcsS0FBSyxDQUFDO2VBQ3hDLENBQUM7UUFFRixPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDO0lBRU8sc0NBQWMsR0FBdEIsVUFBdUIsS0FBK0I7UUFDcEQsT0FBTyxPQUFPLENBQUMsa0JBQWtCLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRU8sc0NBQWMsR0FBdEIsVUFBdUIsS0FBK0I7UUFDcEQsT0FBTyxPQUFPLENBQUMsa0JBQWtCLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztJQUM1QyxDQUFDO0lBRU8sdUNBQWUsR0FBdkIsVUFBd0IsS0FBK0I7UUFDckQsSUFBSSxJQUFJLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxFQUFFO1lBQ3RCLElBQUEsb0JBQW9CLEdBQUssSUFBSSxDQUFDLE1BQU0scUJBQWhCLENBQWlCO1lBRTdDLE9BQU8sb0JBQW9CLGFBQXBCLG9CQUFvQix1QkFBcEIsb0JBQW9CLENBQUUsUUFBUSxDQUFDLEtBQTJCLENBQUMsQ0FBQztTQUNwRTtRQUVELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVPLDZDQUFxQixHQUE3QixVQUE4QixLQUErQjtRQUNuRCxJQUFBLGFBQWEsR0FBSyxJQUFJLENBQUMsTUFBTSxjQUFoQixDQUFpQjtRQUV0QyxPQUFPLGFBQWEsYUFBYixhQUFhLHVCQUFiLGFBQWEsQ0FBRSxRQUFRLENBQUMsS0FBMkIsQ0FBQyxDQUFDO0lBQzlELENBQUM7SUFFTyx3Q0FBZ0IsR0FBeEI7UUFDRSxJQUFNLE1BQU0sR0FBeUUsRUFBRSxDQUFDO1FBQ3hGLElBQU0sV0FBVyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUM7UUFDN0MsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLFdBQVcsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLEVBQUU7WUFDM0MsSUFBTSxPQUFLLEdBQUcsV0FBVyxDQUFDLENBQUMsQ0FBNkIsQ0FBQztZQUN6RCxJQUFJLElBQUksQ0FBQyxlQUFlLENBQUMsT0FBSyxDQUFDLEVBQUU7Z0JBQy9CLGtGQUFrRjtnQkFDbEYsK0JBQStCO2dCQUMvQiw4Q0FBOEM7Z0JBQzlDLCtCQUErQjtnQkFDL0IseUJBQXlCO2dCQUN6QixxQ0FBcUM7Z0JBQ3JDLFdBQVc7Z0JBQ1gsUUFBUTtnQkFDUixTQUFTO2FBQ1Y7WUFFRCxJQUFNLGdCQUFnQixHQUFHLElBQUksQ0FBQyxvQkFBb0IsQ0FBQyxPQUFLLENBQUMsQ0FBQztZQUMxRCxJQUFJLGdCQUFnQixFQUFFO2dCQUNwQixNQUFNLENBQUMsSUFBSSxDQUFDLGdCQUFnQixDQUFDLENBQUM7Z0JBQzlCLFNBQVM7YUFDVjtZQUVELElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxPQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxxQkFBcUIsQ0FBQyxPQUFLLENBQUMsRUFBRTtnQkFDcEUsU0FBUzthQUNWO1lBRUQsZ0ZBQWdGO1lBQ2hGLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBSyxDQUFDLENBQUM7U0FDcEI7UUFFRCxPQUFPLE1BQU0sQ0FBQztJQUNoQixDQUFDO0lBRWEsbUNBQVcsR0FBekI7Ozs7Ozt3QkFDUSxNQUFNLEdBQUcsSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7NkJBSXZCLE1BQU07Ozs7Ozs7Ozs7O3dCQUNkLFVBQVEsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDOzZCQUNwQixPQUFLLEVBQUwsd0JBQUs7d0JBQ1AsVUFBVSxHQUFHLE9BQUssQ0FBQzt3QkFDbkIsV0FBVyxHQUFHLFNBQVMsQ0FBQzt3QkFDeEIsSUFBSSxPQUFPLE9BQUssS0FBSyxRQUFRLEVBQUU7NEJBQzdCLFVBQVUsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDOzRCQUNuQyxXQUFXLEdBQUcsT0FBSyxDQUFDLFVBQVUsQ0FBQyxDQUFDO3lCQUNqQzt3QkFFRCxxQkFBTSxJQUFJLENBQUMsVUFBVSxDQUFDLFVBQVUsRUFBRSxXQUFXLENBQUMsRUFBQTs7d0JBQTlDLFNBQThDLENBQUM7Ozs7Ozs7OztLQUdwRDtJQUVhLCtEQUF1QyxHQUFyRCxVQUFzRCxJQUE4Qjs7O2dCQUNsRiw2Q0FBNkM7Z0JBQzdDLDRFQUE0RTtnQkFDNUUsUUFBUSxJQUFJLEVBQUU7b0JBQ1osS0FBSyxpQkFBaUI7d0JBQ3BCLHNCQUFPLE1BQU0sQ0FBQyxvQ0FBb0MsQ0FBQyxFQUFDO29CQUN0RCxLQUFLLGNBQWM7d0JBQ2pCLHNCQUFPLE1BQU0sQ0FBQyxnQ0FBZ0MsQ0FBQyxFQUFDO29CQUNsRCxLQUFLLGNBQWM7d0JBQ2pCLHNCQUFPLE1BQU0sQ0FBQyxnQ0FBZ0MsQ0FBQyxFQUFDO2lCQUNuRDs7OztLQUNGO0lBRWEsa0NBQVUsR0FBeEIsVUFBeUIsVUFBb0MsRUFBRSxXQUFtRDs7Ozs7OzRCQUM5RSxxQkFBTSxnQkFBZ0IsQ0FBQzs7Z0NBQ3ZELHNCQUFPLElBQUksQ0FBQyx1Q0FBdUMsQ0FBQyxVQUFVLENBQUMsRUFBQzs7NkJBQ2pFLENBQUMsRUFBQTs7d0JBRkksS0FBNEIsU0FFaEMsRUFGTSxNQUFNLFlBQUEsRUFBRSxNQUFNLFlBQUEsRUFBRSxLQUFLLFdBQUE7d0JBSTdCLElBQUksTUFBTSxFQUFFOzRCQUNWLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLGtCQUFXLFVBQVUscUNBQWtDLENBQUMsQ0FBQzs0QkFDbkUsV0FBVyxHQUFJLE1BQXNCLENBQUMsT0FBTyxDQUFDOzRCQUNwRCxJQUFJLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQyxHQUFHO2dDQUN6QixRQUFRLEVBQUUsSUFBSSxXQUFXLENBQUM7b0NBQ3hCLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUztvQ0FDekIsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO29DQUNuQixVQUFVLEVBQUUsV0FBVyxDQUFDLFVBQVUsQ0FBQztpQ0FDZCxDQUFDO2dDQUN4QixXQUFXLGFBQUE7NkJBQ1osQ0FBQzt5QkFDSDs2QkFBTTs0QkFDTCxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxrQkFBVyxVQUFVLCtDQUFxQyxLQUFLLENBQUUsQ0FBQyxDQUFDO3lCQUN0Rjs7Ozs7S0FDRjtJQUNILG9CQUFDO0FBQUQsQ0FBQyxBQTNMRCxJQTJMQztBQUVELGVBQWUsYUFBYSxDQUFDIn0=